(function () {
    ('use strict');
    ('ngInject');

    angular.module('app.ctrls').controller('StampCtrl', stampCtrl);

    function stampCtrl($scope, $routeParams, $window, $cookies) {
        // Expire the cookie in 10 years
        const date = new Date();
        date.setFullYear(date.getFullYear() + 10);

        var existingCookie = $cookies.get('customilyStamp');
        if (!existingCookie) {
            existingCookie = '';
        }
        $cookies.put('customilyStamp', `${existingCookie}-${$routeParams.stampId}`, {
            domain: process.env.VUE_APP_STAMP_COOKIE_DOMAIN,
            expires: date.toUTCString(),
            secure: process.env.NODE_ENV !== 'development'
        });

        setTimeout(function() {
            //timeout to leave enough time for GTM execution
            if ($routeParams.redirectTo) {
                const baseURL = process.env.VUE_APP_CUSTOMILY_BASE_URL;
                $window.location.href = `${baseURL}/signup?storeType=${$routeParams.redirectTo}`;
            } else {
                //added window.location.search to keep GTM query params
                $window.location.href = `https://apps.shopify.com/customily-product-personalizer${window.location.search}`;
            }
        }, 500);
    }
})();
